import React, { useEffect, useState } from "react";
import HeadingComp from "../UdsEmployeeDashboard/CustomHooks/HeadingComp";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import "../../../../StyleSheet/MainComponent/UDSEMployee/LeaveApply.scss";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import fileUpload from "../../../../Assets/MainComponent/fileUpload.svg";
import {
  SetCreateAttendanceRegularizationEmpAction,
  SetCalendarActions,
  SetLeaveTypeDataActions,
  setTheLeaveApplyDateUDS_employee,
} from "../../../../Redux/Slice";
import { useNavigate } from "react-router-dom";
// import Button from "../../../AppComponent/Button/Button";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import dateFormat, { masks } from "dateformat";
import Modal from "react-bootstrap/Modal";
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";



function AttendanceRegularization(props) {
  const {
    PageIndex,
    status,
    search,
    show,
    setShow,

  } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const state = useSelector((state) => state)
  const leaveTypes = useSelector((state) => state.LeaveTypeData.LeaveTypeData);
  const userId = useSelector(
    (state) => state.CustomUDSEMployeeLogin.CustomoginDATAs.data.data.id
  );
  const createLeave = useSelector(
    (state) => state.CreateLeaveCall.createLeaveData
  );

  const calendarResponse = useSelector(
    (state) => state.CalendarCall.CalendarData.data
  );


  const today = new Date();
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth();

  const minDate = new Date(currentYear, currentMonth, 1); // First day of the current month
  const maxDate = new Date(currentYear, currentMonth + 1, 0); // Last day of the current month

  const leaveTypeOptions = [
    { value: "Swipe Missed", label: "Swipe Missed" },
    { value: "Work From Home", label: "Work From Home" },
    { value: "Present", label: "Present" },
    { value: "Other", label: "Other" },



  ];
  leaveTypeOptions.unshift({
    value: "",
    label: "Select type ",
    isDisabled: true,
  });

  const [selectedDates, setSelectedDates] = useState([]);
  const [nonSelectableDates, setNonSelectableDates] = useState([]);

  useEffect(() => {
    const currentDate = new Date();
    const payload = {
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
    };
    dispatch(SetCalendarActions(payload));
  }, []);

  console.log(
    calendarResponse,
    "calendarResponse",
    state.UDSemployeeRoleActions.LeaveApplyedDate
  );
  var applying = [state.UDSemployeeRoleActions.LeaveApplyedDate];
  useEffect(() => {
    if (calendarResponse != undefined && calendarResponse != null) {
      const dates = [];

      calendarResponse.map((item) => {
        console.log(item.date, "76iiututiiuiu");

        if (item.present) {
          dates.push({ fromdata: item.date, todate: null });
        } else if (item.weekoff) {
          console.log(item, "2384238oln d");
          dates.push({ fromdata: item.date, todate: null });
        } else if (item.working) {
          dates.push({ fromdata: item.date, todate: null });
        } else if (item.leave) {
          dates.push({ fromdata: item.date, todate: null });
        }
      });
      state.UDSemployeeRoleActions.LeaveApplyedDate.map((item) => {
        dates.push({ fromdata: item.fromdata, todate: item.todate });
      });
      dispatch(setTheLeaveApplyDateUDS_employee(dates)); /// here update the actions
    }
  }, []);

  useEffect(() => {
    const dates = state.UDSemployeeRoleActions.LeaveApplyedDate.flatMap(
      (item) => {
        const datesArray = [];
        if (item.fromdata) {
          datesArray.push(new Date(item.fromdata));
        }
        if (item.todate) {
          datesArray.push(new Date(item.todate));
        }
        return datesArray;
      }
    );

    // console.log("Non-selectable dates:", dates); // Debugging line to verify dates
    setNonSelectableDates(dates);
  }, [state]);

  const onChange = (date) => {
    fieldErrors.from_date = "";

    const dateString = date.toDateString();
    if (
      selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === dateString
      )
    ) {
      // If the date is already selected, remove it from the array
      setSelectedDates(
        selectedDates.filter(
          (selectedDate) => selectedDate.toDateString() !== dateString
        )
      );
    } else {
      // If the date is not selected, add it to the array
      setSelectedDates([...selectedDates, date]);
    }
  };

  const tileClassName = ({ date, view }) => {
    // Add class to selected dates
    if (
      selectedDates.some(
        (selectedDate) => selectedDate.toDateString() === date.toDateString()
      )
    ) {
      return "highlight";
    }
    return null;
  };

  // const tileDisabled = ({ date, view }) => {
  //   // Check if the current date is in nonSelectableDates
  //   return nonSelectableDates.some(
  //     (item) => item.toDateString() === date.toDateString()
  //   );
  // };

  // const tileDisabled = ({ date, view }) => {
  //   const currentDate = new Date();
  //   const currentYear = currentDate.getFullYear();
  
  //   // Disable if date is in nonSelectableDates or outside the current year
  //   return (
  //     nonSelectableDates.some(
  //       (item) => item.toDateString() === date.toDateString()
  //     ) ||
  //     date.getFullYear() !== currentYear // Disable dates in years other than the current year
  //   );
  // };
  

  const tileDisabled = ({ date, view }) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
  
    // Allow only past dates and the current date within the current year
    return (
      date > currentDate ||               // Disable future dates
      date.getFullYear() !== currentYear   // Disable dates outside the current year
    );
  };
  
  // const tileDisabled = ({ date, view }) => {
  //   // Check if the current date is in nonSelectableDates or is a future date
  //   const isNonSelectableDate = nonSelectableDates.some(
  //     (item) => item.toDateString() === date.toDateString()
  //   );

  //   // const isFutureDate = date > new Date(); // Disables future dates

  //   return isNonSelectableDate ;
  // };


  const [data, setData] = useState({
    continue_leave: false,
    from_date: "",
    to_date: "",
    status: "pending",
    notes: "",
    user_id: state.SideBarFiles.UserIDsemp,
    request_type: "request",
    leave_type: "",
  });
  const [fieldErrors, setFieldErrors] = useState({
    from_date: "",
    to_date: "",
    notes: "",
    leave_type: "",
  });
  const [selectedLeave, setSelectedLeave] = useState({});
  const processedDates = selectedDates.map((date, index) => {
    if (index % 2 === 0) {
      return { type: "from", date }; // Even index, treat as 'from date'
    } else {
      return { type: "to", date }; // Odd index, treat as 'to date'
    }
  });

  function formatDateFields(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is zero-indexed, so add 1
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  const [StateDate, setStateDate] = useState([]);
  const [fromDate, setFromdate] = useState({ from_date: "", to_date: "" });
  useEffect(() => {
    // Example usage:
    var Finaldate = [];

    if (selectedDates != null && selectedDates.length > 0) {
      selectedDates.map((item) => {
        const date = new Date(item);
        var formattedDate = formatDateFields(date);
        Finaldate.push({ value: formattedDate });
      });
      setStateDate(Finaldate);
    }
  }, [selectedDates]);

  useEffect(() => {
    if (StateDate) {
      const datesObject = {};
      if (StateDate.length == 2 || StateDate.length > 2) {
        // Sort StateDate by value (assuming StateDate is an array of objects with a 'value' property)
        StateDate.sort((a, b) => a.value.localeCompare(b.value));

        setFromdate({
          ...fromDate,

          from_date: StateDate[StateDate.length - 1].value,
          to_date: StateDate[0].value,
        });
      } else if (StateDate.length == 1) {
        // Handle case where StateDate is empty
        setFromdate({
          ...fromDate,
          from_date: StateDate[0].value, // Set default value for from_date when StateDate is empty
          to_date: null, // Set default value for to_date when StateDate is empty
        });
      }
    }
  }, [StateDate]);


  const handleSubmit = (e) => {
    // console.log("lkaslfjjasfk");
    e.preventDefault();

    const newFieldErrors = { ...fieldErrors };
    if (fromDate.from_date == "") {
      newFieldErrors.from_date = "From date must not be empty.";
    }
    if (fromDate.from_date != "") {
      newFieldErrors.from_date = "";
    }

    Object.entries(data).forEach(([key, value]) => {
      //   if (key === "notes" && value.trim().length === 0) {
      //     newFieldErrors.notes = "Notes must not be empty.";
      //   } 

      if (key === "leave_type" && value.trim().length === 0) {
        newFieldErrors.leave_type = "Regularization type must not be empty.";
      }


    });
    const hasError = Object.values(newFieldErrors).some((error) => error);
    setFieldErrors(newFieldErrors);
    if (!hasError) {
      const getMonYea = new Date(fromDate.from_date);

      console.log("No errors. Submitting form...");

      const payload = {
        formData: {
          to_date: fromDate.to_date,
          from_date: fromDate.from_date,
          status: data.status,
          user_id: data.user_id,
          request_type: "request",
          remarks: data.leave_type,
          selected_type: "single",
          month: getMonYea.getMonth() + 1,
          year: getMonYea.getFullYear(),
          date: fromDate.from_date,
        },
        GetFilters: {
          status: status,
          search: search,
          page: PageIndex,
          page_size: 20,
          request_type: "request",
          user: data.user_id,

        },
        Requesttype: 2

      };
      dispatch(SetCreateAttendanceRegularizationEmpAction(payload));
      setShow(false)
    }
  };

  useEffect(() => {
    if (userId !== undefined) {
      setData((prev) => ({
        ...prev,
        user_id: userId,
      }));
    }
  }, [userId]);
  useEffect(() => {
    dispatch(SetLeaveTypeDataActions());
  }, []);

  const formatDate = (inputDate) => {
    const date = new Date(inputDate);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };
  const handleDate = (inputDate, name) => {
    const value = formatDate(inputDate);
    setData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const [selectedImage, setSelectedImage] = useState(null);
  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    setSelectedImage(file);
  };
  const handleClose = () => {
    setShow(false);
  }

  return (
    <>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        className="modelman"
        size="lg"
        backdrop="static"
      >
        <Modal.Header className="popHead">
          <Modal.Title>
            {"Attendance Regularization"}
          </Modal.Title>
          <div className="CloseIcon" onClick={handleClose}>
            <CloseOutlinedIcon />
          </div>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            <div className="col section1">
              <label htmlFor="leaveType">
                Regularization<span style={{ color: "red" }}>*</span>
              </label>
              <Select
                className="basic-single"
                classNamePrefix="select"
                defaultValue={leaveTypeOptions[0]}
                isSearchable={true}
                id="leaveType"
                options={leaveTypeOptions}
                onChange={(e) => {
                  setData((prev) => ({
                    ...prev,
                    leave_type: e.value,
                  }));
                  setSelectedLeave((prev) => ({
                    ...prev,
                    leave_type: e.label,
                  }));

                  fieldErrors.leave_type = "";
                }}
              />

              <div className="errorCheckBox">
                {fieldErrors.leave_type && (
                  <>
                    {" "}
                    <span style={{ color: "red" }}>
                      * {fieldErrors.leave_type}
                    </span>
                  </>
                )}
              </div>
            </div>

            <>

              <div className="col mt-3">
                <label
                  htmlFor="to_date"
                >
                  You can also select from to date based
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className=" LeaveApplyCalendar">
                  <Calendar
                    onClickDay={onChange}
                    value={
                      selectedDates.length
                        ? selectedDates[selectedDates.length - 1]
                        : new Date()
                    }
                    // tileClassName={tileClassName}
                    // tileDisabled={tileDisabled}
                    // maxDate={new Date()} // Disables future dates globally
                    // minDate={minDate}

                    // tileClassName={tileClassName}
                    tileDisabled={tileDisabled}
                    // maxDate={maxDate}
                    // minDate={minDate}

                  />
                </div>
              </div>

              {fieldErrors.from_date && (
                <>
                  {" "}
                  <span style={{ color: "red" , marginLeft:'15px'}}>
                    {fieldErrors.from_date}
                  </span>
                </>
              )}

            </>

          </form>
        </Modal.Body>

        <Modal.Footer>
          <div className="RoleButton">


            <button
              className="customButton ButtonCSS"
              style={{ background: "#234492 " }}
              onClick={(e) => {
                setShow(false)
              }}

            >
              cancel
            </button>
            <button
              className="customButton ButtonCSS"
              style={{ background: "#234492 " }}
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </Modal.Footer>

      </Modal>
    </>
  );
}

export default AttendanceRegularization;
